module.exports = __webpack_public_path__ + "img/collapse_closed.eaeb06d1.svg";